import React from "react";
import { get, isEmpty } from "lodash";
import { TableRow, TableCell } from "@material-ui/core";
import { AUDIO_SECTION } from "../../../constants/ContentFinder";
import { displayData, hasAnyValue } from "../../../utils/ContentFinderUtils";
import DrawerTable from "./DrawerTable";

const AudioSection = ({ audioTracks }) => {
  const tracks = [...audioTracks]
    .filter((track) => {
      const properties = get(track, "properties", {});
      return hasAnyValue([
        get(properties, "audioContentKind"),
        get(properties, "soundFieldGroupLayout"),
        get(properties, "soundFieldGroupType"),
        get(properties, "audioChannel"),
        get(properties, "spokenLanguage") ||
          get(properties, "audioContentLanguage"),
      ]);
    })
    .sort((a, b) =>
      a.trackNum === b.trackNum
        ? (b.version || 0) - (a.version || 0)
        : (a.trackNum || 0) - (b.trackNum || 0)
    );

  return (
    <DrawerTable
      title={AUDIO_SECTION.title}
      headers={AUDIO_SECTION.headers}
      isEmpty={isEmpty(tracks)}
      emptyMessage={AUDIO_SECTION.emptyMessage}
    >
      {tracks.map((track, i) => {
        const properties = get(track, "properties", {});
        let isBCP47 = true;
        let audioContentLanguage = get(properties, "spokenLanguage");
        if (!audioContentLanguage) {
          isBCP47 = false;
          audioContentLanguage = get(properties, "audioContentLanguage");
        }
        let soundFieldGroupLayout = get(properties, "soundFieldGroupLayout");
        if (typeof soundFieldGroupLayout === "number") {
          soundFieldGroupLayout = soundFieldGroupLayout.toFixed(1);
        }
        return (
          <TableRow key={i} className="tableRow content-finder-body-row">
            <TableCell className="content-finder-table-cell">
              {displayData(get(properties, "audioContentKind"), {
                titleCase: true,
              })}
            </TableCell>
            <TableCell className="content-finder-table-cell">
              {displayData(soundFieldGroupLayout, {
                removeUnderscores: true,
                titleCase: true,
              })}
            </TableCell>
            <TableCell className="content-finder-table-cell">
              {displayData(get(properties, "soundFieldGroupType"), {
                removeUnderscores: true,
                titleCase: true,
              })}
            </TableCell>
            <TableCell className="content-finder-table-cell">
              {displayData(get(properties, "audioChannel"), { titleCase: true })}
            </TableCell>
            <TableCell className="content-finder-table-cell">
              {displayData(audioContentLanguage, {
                displayLanguage: true,
                isBCP47,
              })}
            </TableCell>
          </TableRow>
        );
      })}
    </DrawerTable>
  );
};

export default AudioSection;
